import dayjs from "dayjs";
import { date, number, object } from "yup";

import { DiscountTypeEnum } from "@/features/shared";

export const DEFAULT_VALUES = {
  transactionDate: dayjs(),
  discount: 0,
  discountInput: 0,
  discountType: DiscountTypeEnum.FIXED_AMOUNT,
  taxable: false,
  totalIncludesTax: false,
  taxPercentage: 11,
  subtotal: 0,
  leftSide: {
    enabled: true,
  },
  rightSide: {
    enabled: true,
  },
};

export const VALIDATION_SCHEMA = object().shape({
  seller: object().required("Harus diisi"),
  warehouse: object().required("Harus diisi"),
  paymentTerm: object().required("Harus diisi"),
  transactionDate: date().required("Harus diisi"),
  subtotal: number()
    .transform((value, originalValue) =>
      String(originalValue).trim() === "" ? undefined : value
    )
    .min(0, "Minimal 0"),
  // `discountInput` is the raw user entry: a percent (0-100) when the type is
  // percentage, otherwise a rupiah amount that cannot exceed the subtotal.
  discountInput: number()
    .transform((value, original) =>
      String(original).trim() === "" ? 0 : value
    )
    .min(0, "Diskon tidak boleh kurang dari 0")
    .when("discountType", {
      is: DiscountTypeEnum.PERCENTAGE,
      then: (schema) => schema.max(100, "Diskon persentase maksimal 100%"),
      otherwise: (schema) =>
        schema.test(
          "not-exceed-subtotal",
          "Diskon tidak boleh melebihi subtotal",
          function (value) {
            return (value || 0) <= (this.parent.subtotal || 0);
          }
        ),
    }),
});
